var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"categories-filter"},_vm._l((_vm.categories),function(category){return _c('div',{key:category.id,staticClass:"categories-filter__item"},[_c('div',{staticClass:"categories-filter__item--title",on:{"click":function($event){return _vm.makeCategoryActive(category.id)}}},[_vm._v(_vm._s(category.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }